import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormikContext } from 'formik';
import React from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CreateApplicationFormValues } from '../../views/ApplicationCreate';
import ApplicationJobCreate from './ApplicationJobCreate';

const ApplicationJobsCreate = (): React.ReactElement => {
  const { t } = useTranslation(['createApplication', 'common']);

  const { values, setFieldValue } = useFormikContext<CreateApplicationFormValues>();

  return (
    <Card className="mb-2">
      <Card.Body>
        <Row>
          <Col>
            <h4>{t('jobs')}</h4>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <p className="small text-muted">{t('jobHelp')}</p>
          </Col>
          <Col md="8">
            {' '}
            <Form.Group>
              {values.job.map((_, i) => (
                <ApplicationJobCreate key={`job-${i}`} index={i} />
              ))}

              <Button
                type="button"
                variant="secondary"
                className="float-right"
                onClick={(e) =>
                  setFieldValue('job', [
                    ...values.job,
                    {
                      job: '',
                      company: '',
                      description: '',
                    },
                  ])
                }
              >
                <FontAwesomeIcon icon={faPlusCircle} /> {t('addJob')}
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default ApplicationJobsCreate;
